export default __webpack_public_path__ + "static/media/Gauntlets of the Scattered Gods.53ac24bd.jpg";